
export const services = [
  { id: 1, label: "Lab" },
  { id: 2, label: "Pile Load Test" },
  { id: 3, label: "NDT" },
  { id: 4, label: "Rock Anchoring" },
  { id: 5, label: "Geotech" },
  { id: 6, label: "Geophysical" },
  { id: 7, label: "Road Inventory" },
];